/**
 * Call a given function with the given value, then return the value
 */
export function tap<T>(tappable: T, callback: (tappable: T) => void): T {
  callback(tappable)

  return tappable
}
